import math, { re } from 'mathjs';
import {QListCountArray, TwoQListCountArray} from '../components/vectors/canvas'
import {getQuadrant, calculateMagnitude, getAngleDeg} from '../components/vectors/vectors'

export const vector_colors = ['#F79722', '#0AAAFA', '#FF5500', '#09B83E', '#34465D', '#E4405F'];
import { EvaluateOptions,QueryOptions } from "../common/functions";
import { DEFAULT_VECTOR_SNAP_TO_GIRD } from '../common/constants';
let Quadarant = [];
let Magnitude = [];
let Direction = [];
let CountArr = [];
let ConcatArr = [];

function replaceAll(string, token, newtoken) {
    if (string && token !== newtoken)
        while (string.indexOf(token) > -1) {
            string = string.replace(token, newtoken);
        }
    return string;
}

function getRandomFloat(min, max, blackList) {
    min = parseFloat(min);
    max = parseFloat(max);

    if (!blackList || blackList.length === 0) {
        return +math.round(math.random(min, max), 1);
    }

    while (true) {
        let value = +math.round(math.random(min, max), 1);
        if (blackList.find(num => parseFloat(num) === value) === undefined) {
            return value;
        }
    }
}

function getRandomInt(
    min,
    max,
    blackList,
) {

    if (!blackList) {
        return math.randomInt(parseInt(min, 10), parseInt(max, 10) + 1);
    }

    while (true) {
        let value = math.randomInt(parseInt(min, 10), parseInt(max, 10) + 1);

        if (blackList.find((num) => {
                return parseInt(value, 10) === parseInt(num, 10);
            }) === undefined) {
            return value;
        }
    }
}

function stringToNumberArray(rpBlackList) {
    if (rpBlackList) {
        const arrRpBlackList = [];
        rpBlackList.split(",").forEach(strNum => {
            if (strNum.includes(".") || strNum.includes("e")) {
                arrRpBlackList.push(parseFloat(strNum));
            } else {
                arrRpBlackList.push(parseInt(strNum, 10));
            }
        });

        return arrRpBlackList;
    }

    return [];
}

export class VectorVariable {
    constructor() {
        this.type = undefined;
        this.inputType = 'components';
        this.x = '5';
        this.y = '5';
        this.z = '5';
        this.xMin = '0';
        this.yMin = '0';
        this.xMax = '5';
        this.yMax = '5';
        this.xList = '';
        this.yList = '';
        this.mag = '0';
        this.magnitude = '0';
        this.angle = '0';
        this.ang = '0';
        this.color = '#0850f7';
        this.direction = '';
        this.angleOptions = {
            angleOffset: 0,
            type: 2,
            clockwise: true
        }
        this.variableType = "RANGE";
        this.posX = '5';
        this.posY = '5';
        this.name = '';
        this.draggable = false;
        this.strokeWidth = 5;
        this.gridWidthUnit = '10';
        this.gridHeightUnit = '10';
    }

    static generateValue(variable, enableIdenticalVectors, vectorSettingsData) {
        const {
            vectorBlackListX,
            vectorBlackListY,
            vectorBlackListAngle,
            vectorBlackListMagnitude,
            gridHeightUnit, 
            gridWidthUnit,
        } = variable;
        
        variable.strokeWidth = 5;
        const getRandomIntValue = (value, min, max) => {
            if(value && value != null && value != "") {
                const ArrayList = value.replaceAll(" ", "").split(",").filter((num) => ((num != "" && Number(num) >= Number(min) && Number(num) <= Number(max))));
                const randomIndex = Math.floor(Math.random() * ArrayList.length);
                return ArrayList[randomIndex];
            } else {
                return "0";
            }
        }

        const getRandomNumberFromList = (value) => {
            if(value && value != null && value != "") {
                const ArrayList = value.replaceAll(" ", "").split(",").filter((num) => num != "").map(Number);
                const randomIndex = Math.floor(Math.random() * ArrayList.length);
                return ArrayList[randomIndex] ? ArrayList[randomIndex] : 0;
            } else {
                return 0;
            }
        }

        let snapToGrid = DEFAULT_VECTOR_SNAP_TO_GIRD;
        if (vectorSettingsData && vectorSettingsData.isSnapToGridOff !== null && vectorSettingsData.isSnapToGridOff !== undefined) {
            snapToGrid = !vectorSettingsData.isSnapToGridOff;
        }

        switch (variable.inputType) {
            case 'components':
                if (variable.variableType) {
                    if(variable.variableType === "LIST") {
                        variable.x = getRandomIntValue(variable.xList, -(gridWidthUnit / 2), (gridWidthUnit / 2));
                        variable.y = getRandomIntValue(variable.yList, -(gridHeightUnit / 2), (gridHeightUnit/ 2));
                        variable.z = getRandomIntValue(variable.zList, -(this.gridHeightUnit / 2), (this.gridHeightUnit / 2));
                    } else {
                        const vectorBlackListXArray = stringToNumberArray(vectorBlackListX);
                        const vectorBlackListYArray = stringToNumberArray(vectorBlackListY);
                        let i = 0;
                        control_start: while(true) {
                            i++;
                            //For avoid system freeze
                            if(i > 20){
                                break;
                            }
                            if (variable.variableType === "RANGE") {
                                variable.x = getRandomInt(variable.xMin,variable.xMax,vectorBlackListXArray);
                                variable.y = getRandomInt(variable.yMin,variable.yMax,vectorBlackListYArray);
                                variable.z = getRandomInt(variable.zMin,variable.zMax, []);
                            } else { // RANGE CONTINOUS
                                variable.x = getRandomFloat(variable.xMin,variable.xMax,vectorBlackListXArray);
                                variable.y = getRandomFloat(variable.yMin,variable.yMax,vectorBlackListYArray);
                                variable.z = getRandomFloat(variable.zMin,variable.zMax,[]);
                            }

                            Quadarant.push(getQuadrant(variable.x, variable.y, variable.posX,variable.posY,variable.gridWidthUnit,variable.gridHeightUnit))
                            Magnitude.push(calculateMagnitude(variable))
                            Direction.push(getAngleDeg(variable))
                            //Randomize if Question Vector has a Zero Vector
                            // if(Magnitude.some((m)=> m === 0)){
                            //     console.log("Zero Vector Generated. So Randomizing Now..")
                            //     Quadarant.pop();
                            //     Magnitude.pop();
                            //     Direction.pop();
                            //     continue  control_start;
                            // }
                            if(Quadarant.length > 1){
                                CountArr = QListCountArray(Quadarant)
                                ConcatArr = TwoQListCountArray(Magnitude, Direction)
                            }
                            /* We can control vector generation in the same quadrant here.
                            FYI: C>N Where N = Number of times can occur */
                            let checkMorethan3VectorsInQuadrant = CountArr.some((c)=> c>3)
                            let checkTwoVectorsSameMagnitudeDirection = ConcatArr.some((c)=> c>1)   
                            if(checkMorethan3VectorsInQuadrant || (!enableIdenticalVectors && checkTwoVectorsSameMagnitudeDirection)){
                                Quadarant.pop();
                                Magnitude.pop();
                                Direction.pop();
                                CountArr = [];
                                ConcatArr = [];
                                continue  control_start;
                            }
                            break;
                        }
                    }
                    
                }

                break;
            case 'angle-magnitude':

                const vectorBlackListAngleArray = stringToNumberArray(vectorBlackListAngle);
                const vectorBlackListMagnitudeArray = stringToNumberArray(vectorBlackListMagnitude);
                /* const angleVarType = (variable.angleVariableType && variable.angleVariableType !== "")
                    ? variable.angleVariableType
                    : variable.variableType;
                const magVarType = (variable.magVariableType && variable.magVariableType !== "")
                    ? variable.magVariableType
                    : variable.variableType; */
                
                const angleVarType = variable.angleVariableType ? variable.angleVariableType : "INT";
                const magVarType = variable.magVariableType ? variable.magVariableType : "INT";

                // Generate angle based on its own variable type
                if (angleVarType === "FLOAT") {
                    if(variable.angleMax == 0 && variable.angleMax === "") {
                        variable.angle = 0
                    } else {
                        variable.angle = getRandomFloat(parseFloat(variable.angleMin),parseFloat(variable.angleMax),vectorBlackListAngleArray);
                    }
                } else if (angleVarType === "INT") {
                    if(variable.angleMax == 0 && variable.angleMax === "") {
                        variable.angle = 0
                    } else {
                        variable.angle = getRandomInt(parseInt(variable.angleMin),parseInt(variable.angleMax),vectorBlackListAngleArray,snapToGrid);
                    }
                } else if (angleVarType === "LIST") {
                    variable.angle = getRandomNumberFromList(variable.angleList);
                }

                // Generate magnitude based on its own variable type
                if (magVarType === "FLOAT") {
                    if(variable.magMax == 0 && variable.magMax === "") {
                        variable.mag = 0
                    } else {
                        variable.mag = getRandomFloat(parseFloat(variable.magMin),parseFloat(variable.magMax),vectorBlackListMagnitudeArray);
                    }
                } else if (magVarType === "INT") {
                    if(variable.magMax == 0 && variable.magMax === "") {
                        variable.mag = 0
                    } else {
                        variable.mag = getRandomInt(parseInt(variable.magMin),parseInt(variable.magMax),vectorBlackListMagnitudeArray,snapToGrid);
                    }
                } else if (magVarType === "LIST") {
                    variable.mag = getRandomNumberFromList(variable.magList);
                }
                variable.ang = variable.angle
                variable.magnitude = variable.mag
                
                variable.x = Math.cos(variable.angle * (Math.PI / 180)) * parseFloat(variable.mag);
                variable.y = Math.sin(variable.angle * (Math.PI / 180)) * parseFloat(variable.mag);
                break;
            default:
                break;

        }
    }

}



export class VectorVariableMap extends Map {

    constructor() {
        super();
        this.isNew = true; 
    }

    containsAll = function (targetMap) {
        if (targetMap && (targetMap instanceof Map)) {
            for (var key of this.keys()) {
                if (!targetMap.has(key))
                    return false;
            }
        } else {
            throw new Error("Method containsAll : argument not of type map")
        }

        return true;
    }

    isValid = function () {


        return true;
    }

    getValidationError = function () {
        let validationError = '';

        return validationError;
    }

    //Validates and Generates Values for the Variables in Map
    //Throws Error if Validation Failes
    generateValues = function (enableIdenticalVector, vectorSettingsData) {
        this.forEach(
            (value, key, map) => {

                VectorVariable.generateValue(value, enableIdenticalVector, vectorSettingsData);

            }
        );
        Quadarant = [];
        Magnitude = [];
        Direction = [];
        CountArr = [];
        ConcatArr = [];
    }

    //For finding vector lengh and sorting based on ascending length 
    getMagnitudeAndSort = function(Arr){
        let VectorMagArr = [];
        let VectorDirArr = [];
        let VectorArrays = [];
        VectorArrays = [...Arr]
        VectorArrays.forEach((VectorValues) =>{
            VectorMagArr.push(calculateMagnitude(VectorValues)) 
            VectorDirArr.push(getAngleDeg(VectorValues))
        })
        let newMagVectorArr = [];
        newMagVectorArr = [...VectorMagArr]
        // newMagVectorArr = newMagVectorArr.sort().reverse();
        let insideIndex = [];
        let indexes = newMagVectorArr.map((value)=> {
          if(insideIndex.includes(VectorMagArr.indexOf(value))){
            let currentPosition = VectorMagArr.indexOf(value);
            loop_start: while(true) {
                currentPosition += 1
                if(insideIndex.includes(VectorMagArr.indexOf(value, currentPosition))) continue loop_start;
                insideIndex.push(VectorMagArr.indexOf(value, currentPosition))
                break;
            }
            return VectorMagArr.indexOf(value, currentPosition)
          }
          insideIndex.push(VectorMagArr.indexOf(value))
          return VectorMagArr.indexOf(value)
        })
        let finalVectorArr = indexes.map(value => VectorArrays[value])
        
        return finalVectorArr;
    }

    //get Vector Array
    getVectorsArray = function (enableIdenticalVector, vectorSettingsData) {
        console.debug("this.isNew>>>", this.isNew)
        if (this.isNew) {
            this.generateValues(enableIdenticalVector, vectorSettingsData);    
        }
        let generatedSortingVectors = this.getMagnitudeAndSort(Array.from(this.values()));
        //return Array.from(this.values());
        return generatedSortingVectors;
    }

    static encodeKey(key) {
        return encodeURIComponent(key);
    }

    // Method to decode keys
    static decodeKey(encodedKey) {
        return decodeURIComponent(encodedKey);
    }

    // Converts the map to a JSON string
    toString() {
        const obj = {};
        this.forEach((value, key) => {
            const encodedKey = VectorVariableMap.encodeKey(key);
            obj[encodedKey] = value;
        });
        return JSON.stringify(obj);
    }

    // Creates an instance of VectorVariableMap from a JSON string
    static fromString(str) {
        const obj = JSON.parse(str);
        const variableMap = new VectorVariableMap();
        for (const [encodedKey, value] of Object.entries(obj)) {
            const key = VectorVariableMap.decodeKey(encodedKey);
            variableMap.set(key, value);
        }
        variableMap.isNew = false;
        return variableMap;
    }
}

export default class VectorParserUtil {
    static getVariablesFromText = (strQuestionText, variablesMap, vectorSettingsData) => {
        //
        if (variablesMap === undefined || variablesMap === null) {
            variablesMap = VectorParserUtil.createMap();
        }

        let variableArray = strQuestionText.match(/[^[\]]+(?=])/g);

        const formatValue = (value) => value.toString();

        if (variableArray && variableArray.length > 0) {
            variableArray.forEach(variable => {
                if (!variablesMap.has(variable)) {
                    let gridSettings = vectorSettingsData;
                    let variableObj = new VectorVariable();
                    variableObj.name = variable;
                    if(gridSettings && gridSettings != undefined) {
                        if(variableObj.autoOrigin){
                            variableObj.posX = formatValue(Math.trunc((variableObj.gridWidthUnit / 2) - (variableObj.x/2)));
                            variableObj.posY = formatValue(Math.trunc((variableObj.gridHeightUnit / 2) - (variableObj.y/2)));
                            console.log(variableObj.name," = ","Auto X-Orgin", variableObj.posX, "Auto Y-Orgin", variableObj.posY) 
                        }else{
                           variableObj.posX = formatValue(Math.trunc(gridSettings.widthUnit / 2));
                           variableObj.posY = formatValue(Math.trunc(gridSettings.heightUnit / 2)); 
                        }
                        variableObj.xMax = formatValue(Math.trunc(gridSettings.widthUnit / 2));
                        variableObj.xMin = formatValue(-Math.trunc(gridSettings.widthUnit / 2));
                        variableObj.yMax = formatValue(Math.trunc(gridSettings.widthUnit / 2));
                        variableObj.yMin = formatValue(-Math.trunc(gridSettings.widthUnit / 2));
                        variableObj.gridWidthUnit = formatValue(gridSettings.widthUnit);
                        variableObj.gridHeightUnit = formatValue(gridSettings.heightUnit);
                    }
                    console.log("variableObj = ", variableObj)
                    variablesMap.set(variable, variableObj);
                }

            });


            for (var key of variablesMap.keys()) {
                if (!variableArray.includes(key))
                    variablesMap.delete(key);
            }
            return variablesMap;
        }


    }

    //Creates a Map and Adds custom helper functions before returing
    static createMap() {
        return new VectorVariableMap();
    }

    static getAnswerFormulasArrayFromText = (strAnswerText) => {
        return strAnswerText.match(/[^[\]]+(?=])/g);
    }

    static computeFormula = (formulaString, variablesMap) => {
        let localStrQuestionText = formulaString;


        if (variablesMap === undefined || variablesMap === null || Object.keys(variablesMap)?.length === 0) {
            return 0;
        }


        for (var key of variablesMap.keys()) {
            localStrQuestionText = replaceAll(localStrQuestionText, `${key}_x`, variablesMap.get(key).x ?? 1);
            localStrQuestionText = replaceAll(localStrQuestionText, `${key}_y`, variablesMap.get(key).y ?? 1);
            localStrQuestionText = replaceAll(localStrQuestionText, `${key}_z`, variablesMap.get(key).z ?? 1);

            let angle_in_degree = variablesMap.get(key).angle ?? 1;
            let angle_in_rad = angle_in_degree * (Math.PI / 180);
            localStrQuestionText = replaceAll(localStrQuestionText, `${key}_angle`, angle_in_degree);
            localStrQuestionText = replaceAll(localStrQuestionText, `${key}_magnitude`, variablesMap.get(key).mag ?? 1);

            localStrQuestionText = replaceAll(localStrQuestionText, `${key}_ang`, angle_in_degree);
            localStrQuestionText = replaceAll(localStrQuestionText, `${key}_mag`, variablesMap.get(key).mag ?? 1);

        }
        try {
            console.debug("localStrQuestionText>>??", localStrQuestionText)
            return math.eval(localStrQuestionText);
        } catch {
            return 0;
        }

    }

    //For finding vector lengh and sorting based on ascending length 
    static getMagnitudeAndSort = function(Arr){
        let VectorMagArr = [];
        let VectorDirArr = [];
        let VectorArrays = [];
        VectorArrays = [...Arr]
        VectorArrays.forEach((VectorValues) =>{
            VectorMagArr.push(calculateMagnitude(VectorValues)) 
            VectorDirArr.push(getAngleDeg(VectorValues))
        })
        let newMagVectorArr = [];
        newMagVectorArr = [...VectorMagArr]
        newMagVectorArr = newMagVectorArr.sort().reverse();
        let insideIndex = [];
        let indexes = newMagVectorArr.map((value)=> {
          if(insideIndex.includes(VectorMagArr.indexOf(value))){
            let currentPosition = VectorMagArr.indexOf(value);
            loop_start: while(true) {
                currentPosition += 1
                if(insideIndex.includes(VectorMagArr.indexOf(value, currentPosition))) continue loop_start;
                insideIndex.push(VectorMagArr.indexOf(value, currentPosition))
                break;
            }
            return VectorMagArr.indexOf(value, currentPosition)
          }
          insideIndex.push(VectorMagArr.indexOf(value))
          return VectorMagArr.indexOf(value)
        })
        let finalVectorArr = indexes.map(value => VectorArrays[value])
        
        return finalVectorArr;
    }

    //Same validation as Random Param free response (errorPercentage / valueRange / precision)
    static isWithinValidationRange(selectedVariable, answerVariable, validationOptions) {
        const { validationMode, errorPercentageRange, errorAbsoluteRange, answerPrecision } = validationOptions;
        const selectedValue = parseFloat(selectedVariable);
        const correctAnswer = parseFloat(answerVariable);
        if (isNaN(selectedValue) || isNaN(correctAnswer)) {
            return false;
        }
        if (validationMode === "errorPercentage") {
            let accuracyRange = parseFloat(errorPercentageRange);
            if (isNaN(accuracyRange)) {
                accuracyRange = 0; //0% default (exact answer)
            }
            const acceptedDeviationValue = Math.abs(correctAnswer * (accuracyRange / 100));
            return (correctAnswer - acceptedDeviationValue) <= selectedValue && selectedValue <= (correctAnswer + acceptedDeviationValue);
        } else if (validationMode === "valueRange") {
            const absAccuracyValue = Math.abs(parseFloat(errorAbsoluteRange));
            if (isNaN(absAccuracyValue)) {
                return selectedValue == correctAnswer;
            }
            return (correctAnswer - absAccuracyValue) <= selectedValue && selectedValue <= (correctAnswer + absAccuracyValue);
        } else if (validationMode === "precision") {
            const precision = parseInt(answerPrecision, 10);
            if (isNaN(precision) || precision < 1 || precision > 100) {
                return selectedValue == correctAnswer;
            }
            return selectedValue.toPrecision(precision) === correctAnswer.toPrecision(precision);
        }
        return selectedValue == correctAnswer;
    }

    static EvaluateVectorQueryOptions(selectedVariable,evaluateCondition,Formula,variablesMap,validationOptions){
        let isCorrect  = false
        let answerVariable = VectorParserUtil.computeFormula(Formula, variablesMap)
        // console.debug("answerVariable>>??", answerVariable)
        //console.log("Vector answer Range----------_>--->select condition answer ",selectedVariable,evaluateCondition,answerVariable)
        if (evaluateCondition == 0) {
            //Equal to
            if (validationOptions && validationOptions.validationMode) {
                isCorrect = VectorParserUtil.isWithinValidationRange(selectedVariable, answerVariable, validationOptions)
            } else {
                isCorrect = selectedVariable == answerVariable
            }
        } else if (evaluateCondition == 1) {
            //Greater than
            isCorrect = selectedVariable > answerVariable

        }else if (evaluateCondition == 2) {
             //Less than
             isCorrect = selectedVariable < answerVariable
            
        }else if (evaluateCondition == 3) {
             //Greater than or equal to
             isCorrect = selectedVariable >= answerVariable
            
        }else if (evaluateCondition == 4) {
             //less than or equal to
             isCorrect = selectedVariable <= answerVariable
       
        }
        return isCorrect
    }
    static generateAnswerVector = (vectorAnswerFormula, variablesMap, vectorSettings) => {
        if (!vectorAnswerFormula || !variablesMap) {
            return null
        }
        //console.log("correctAnswerVectors-------->vectorAnswerFormula",vectorAnswerFormula)
        let answerVector = new VectorVariable();
        const {
            angleFormula,
            formulaType,
            magFormula,
            name,
            xFormula,
            yFormula,
            showLabel,
            showImage,
            showComponents,
            showAngle,
            xOrigin,
            yOrigin,
            autoOrigin,
            formulaColor,
            evaluate_x,
            evaluate_y,
            evaluate_magnitue,
            evaluate_angle,
            xEvaluateOption,
            xEvaluateOptionTwo,
            yEvaluateOption,
            yEvaluateOptionTwo,
        } = vectorAnswerFormula;
        console.debug("vectorAnswerFormula>>>", vectorAnswerFormula)
        answerVector.name = name;
        answerVector.type = formulaType;
        answerVector.color = formulaColor;
        switch (formulaType) {
            case 'components': {
                answerVector.x = evaluate_x === 0 ? VectorParserUtil.computeFormula(xFormula, variablesMap) : 0
                answerVector.y = evaluate_y === 0 ?VectorParserUtil.computeFormula(yFormula, variablesMap) : 0
                if (xEvaluateOption === 1 || xEvaluateOptionTwo === 1) { // >
                    answerVector.x += 1;
                }
                if (yEvaluateOption === 1 || yEvaluateOptionTwo === 1) { // >
                    answerVector.y += 1;
                }
                if (xEvaluateOption === 2 || xEvaluateOptionTwo === 2) { // <
                    answerVector.x -= 1;
                }
                if (yEvaluateOption === 2 || yEvaluateOptionTwo === 2) { // <
                    answerVector.y -= 1;
                }
                break;
            }
            case 'angle-magnitude': {
                answerVector.angle = evaluate_angle === 0 ?  VectorParserUtil.computeFormula(angleFormula, variablesMap) : 0
                answerVector.mag = evaluate_magnitue === 0 ?  VectorParserUtil.computeFormula(magFormula, variablesMap) : 4 // 4 here because we need some mag to get the correct x and y

                answerVector.ang = answerVector.angle
                answerVector.magnitude = answerVector.mag

                answerVector.x = Math.cos(answerVector.angle * (Math.PI / 180)) * parseFloat(answerVector.mag);
                answerVector.y = Math.sin(answerVector.angle * (Math.PI / 180)) * parseFloat(answerVector.mag);

                break;
            }
            default:
                break
        }
        answerVector["showLabel"] = showLabel;
        answerVector["showImage"] = showImage;
        answerVector["showComponents"] = showComponents;
        answerVector["showAngle"] = showAngle;
        
        if(vectorSettings) {
            const gridwidth = parseInt((vectorSettings.width / vectorSettings.stepSize),10);
            const gridheight = parseInt((vectorSettings.height / vectorSettings.stepSize),10);
            answerVector["gridWidthUnit"] = gridwidth;
            answerVector["gridHeightUnit"] = gridheight;

            const xorigin = (gridwidth/2 - answerVector.x/2).toFixed(0);
            const yorigin = (gridheight/2 - answerVector.y/2).toFixed(0);
            if(autoOrigin){
                answerVector["posX"] = xorigin;
                answerVector["posY"] = yorigin;
            }else{
                answerVector["posX"] = xOrigin;
                answerVector["posY"] = yOrigin;
            }
            

        } else {
            answerVector["posX"] = vectorAnswerFormula.posX;
            answerVector["posY"] = vectorAnswerFormula.posY;
        }

        console.log("correctAnswerVectors-------->answerVector",answerVector)
        return answerVector;
    }

    static buildQuestionVariablesMap(variablesArray) {
        let variablesMap = VectorParserUtil.createMap();
        if (variablesArray) {
            variablesArray.forEach((variable, index) => {
                variablesMap.set(variable.name, {...variable, index: index});
            });
        }

        return variablesMap;
    }
    static shouldRandomize(answerFormulaArr, gridWidthUnit,gridHeightUnit){
        let magArr = [];
        let DirArr = [];
        let countArr = [];

        for(let index=0;index<answerFormulaArr.length; index++){
            let answer = answerFormulaArr[index];
            if(answer){
                if(answer && answer.hasOwnProperty('x') && answer.hasOwnProperty('y')){ 
                    magArr.push(calculateMagnitude({...answer, gridWidthUnit,gridHeightUnit})) 
                    DirArr.push(getAngleDeg({...answer, gridWidthUnit,gridHeightUnit}))  
                } 
            }
        }

        if(magArr.length > 1){
            magArr = magArr.filter((mag)=> mag !== null)
            DirArr = DirArr.filter((dir)=> dir !== null)
            countArr = TwoQListCountArray(magArr,DirArr)
        }

        for(let ix = 0; ix < countArr.length; ix++){
            if(countArr[ix]> 1){
                    return true;
            }
        }

        return false;
    }
    static getAllCorrectAnswers(vector_answer_formulas, currentVectorVariable){
        let correctAnswers = [];
        if(!vector_answer_formulas)
            return correctAnswers;
        for(let index = 0;index < vector_answer_formulas.length;index++){
            const correctAnswerVector = VectorParserUtil.generateAnswerVector(vector_answer_formulas[index], currentVectorVariable);
            correctAnswers.push(`{x:${correctAnswerVector.x},y:${correctAnswerVector.y}}`)
        }
        return correctAnswers;
    }
    static getAllSelectedAnswers(selectedAnswer, variablesMap){
        let selectedAnswers = [];
        if(!selectedAnswer)
            return selectedAnswers;
        for (var key of variablesMap.keys()) {
            const match = key.match(/\\vec{(.*)}/);
            const vectorName = match && match[1] ? match[1] : key;
            selectedAnswers.push(
                `Vector ${vectorName} - x:${variablesMap.get(key).x} y:${variablesMap.get(key).y}`
            );
            // selectedAnswers.push(`Vector ${key.match(/\\vec{(.*)}/)[1]} - x:${variablesMap.get(key).x} y:${variablesMap.get(key).y}`);
        }
        let i = 0;
        for (const [key, value] of Object.entries(selectedAnswer)) {
            selectedAnswers.push(`Student response ${++i} - x:${value.x} y:${value.y}`);
        }   
        return selectedAnswers;
    }
    static isAnswerCorrect(vector_answer_formulas, selectedAnswers, currentVectorVariable,currentVectorSettings) {
        if(!vector_answer_formulas)
            return false;
        for(let index = 0;index < vector_answer_formulas.length;index++){
            if(selectedAnswers && !selectedAnswers[index]){
                return false;
            }
            let isCorrectAnswer;
            //Existing questions have no validation mode, default to error percentage with 0% (exact answer)
            const formulaValidationMode = vector_answer_formulas[index]?.validationMode;
            const formulaErrorPercentageRange = vector_answer_formulas[index]?.errorPercentageRange;
            const validationOptions = {
                validationMode: formulaValidationMode === null || formulaValidationMode === undefined ? "errorPercentage" : formulaValidationMode,
                errorPercentageRange: formulaErrorPercentageRange === null || formulaErrorPercentageRange === undefined ? 0 : formulaErrorPercentageRange,
                errorAbsoluteRange: vector_answer_formulas[index]?.errorAbsoluteRange,
                answerPrecision: vector_answer_formulas[index]?.answerPrecision,
            };

            //Vector Answer Range Enabled
            console.log("Vector answer Range----------_>",vector_answer_formulas)
           if (vector_answer_formulas[index]?.formulaType === "components") {
               //Components
               if(vector_answer_formulas[index]?.evaluate_x === 0 || vector_answer_formulas[index]?.evaluate_y === 0 ) {
   
                   let isCorrectAnswerX = false;
                   let isCorrectAnswerY = false;
                   if (vector_answer_formulas[index]?.evaluate_x === 0) {
                       const xFormulaCondition = vector_answer_formulas[index]?.xEvaluateOption;
                       const xFormula = vector_answer_formulas[index]?.xFormula;
                       const xQueryOption = vector_answer_formulas[index]?.xQueryOption;
                       const xFormulaConditionTwo = vector_answer_formulas[index]?.xEvaluateOptionTwo;
                       const xFormulaTwo = vector_answer_formulas[index]?.xFormulaTwo;
                       const xAddFormulaFormulaOption = vector_answer_formulas[index]?.xAddFormulaSwitch;
   
                       let isXFormulaOneCorrect = VectorParserUtil.EvaluateVectorQueryOptions(selectedAnswers[index]?.x,xFormulaCondition,xFormula,currentVectorVariable,validationOptions)
                       
                       if(xAddFormulaFormulaOption){
                           let isXFormulaTwoCorrect = VectorParserUtil.EvaluateVectorQueryOptions(selectedAnswers[index]?.x,xFormulaConditionTwo,xFormulaTwo,currentVectorVariable,validationOptions)
                           if (xQueryOption == 0 ) {
                               //AND operator
                               isCorrectAnswerX = isXFormulaOneCorrect && isXFormulaTwoCorrect;
                           } else if (xQueryOption == 1) {
                               //OR operator
                               isCorrectAnswerX = isXFormulaOneCorrect || isXFormulaTwoCorrect;
                           }
                       } else {
                           isCorrectAnswerX = isXFormulaOneCorrect
                       }
                       //console.log("Vector answer Range----------_>xcorrect--->",isXFormulaOneCorrect,xAddFormulaFormulaOption,isCorrectAnswerX)
   
                   }
   
                   if (vector_answer_formulas[index]?.evaluate_y  === 0) {
                       const yFormulaCondition = vector_answer_formulas[index]?.yEvaluateOption;
                       const yFormula = vector_answer_formulas[index]?.yFormula;
                       const yQueryOption = vector_answer_formulas[index]?.yQueryOption;
                       const yFormulaConditionTwo = vector_answer_formulas[index]?.yEvaluateOptionTwo;
                       const yFormulaTwo = vector_answer_formulas[index]?.yFormulaTwo;
                       const yAddFormulaFormulaOption = vector_answer_formulas[index]?.yAddFormulaSwitch;
   
                       let isYFormulaOneCorrect = VectorParserUtil.EvaluateVectorQueryOptions(selectedAnswers[index]?.y,yFormulaCondition,yFormula,currentVectorVariable,validationOptions)
                       
                       if(yAddFormulaFormulaOption){
                           let isYFormulaTwoCorrect = VectorParserUtil.EvaluateVectorQueryOptions(selectedAnswers[index]?.y,yFormulaConditionTwo,yFormulaTwo,currentVectorVariable,validationOptions)
                           if (yQueryOption == 0) {
                               //AND operator
                               isCorrectAnswerY = isYFormulaOneCorrect && isYFormulaTwoCorrect;
                           } else if (yQueryOption == 1) {
                               //OR operator
                               isCorrectAnswerY = isYFormulaOneCorrect || isYFormulaTwoCorrect;
                           }
                       } else {
                           isCorrectAnswerY = isYFormulaOneCorrect;
                       }
                       //console.log("Vector answer Range----------_>ycorrect--->",isYFormulaOneCorrect,isYFormulaTwoCorrect,isCorrectAnswerY)
   
                   }
   
                   if (vector_answer_formulas[index]?.evaluate_x === 0 && vector_answer_formulas[index]?.evaluate_y === 0) {
                       isCorrectAnswer = isCorrectAnswerX && isCorrectAnswerY
                   } else if (vector_answer_formulas[index]?.evaluate_x === 0) {
                       isCorrectAnswer = isCorrectAnswerX 
                   }else if (vector_answer_formulas[index]?.evaluate_y === 0) {
                       isCorrectAnswer = isCorrectAnswerY
                   }
   
                   console.log("Vector answer Range----------_>finalcorrectanswer",isCorrectAnswer,isCorrectAnswerX,isCorrectAnswerY)
               }
           } else {
               //angle magnitude
               if(vector_answer_formulas[index]?.evaluate_magnitue === 0 || vector_answer_formulas[index]?.evaluate_angle === 0 ) {
   
                   let isCorrectAnswerMag = false;
                   let isCorrectAnswerAng = false;
                   if (vector_answer_formulas[index]?.evaluate_magnitue === 0) {
                       const magFormulaCondition = vector_answer_formulas[index]?.magEvaluateOption;
                       const magFormula = vector_answer_formulas[index]?.magFormula;
                       const magQueryOption = vector_answer_formulas[index]?.magQueryOption;
                       const magFormulaConditionTwo = vector_answer_formulas[index]?.magEvaluateOptionTwo;
                       const magFormulaTwo = vector_answer_formulas[index]?.magFormulaTwo;
                       const magAddFormulaFormulaOption = vector_answer_formulas[index]?.magAddFormulaSwitch;

                       console.debug("currentVectorVariable>>??", currentVectorVariable, magFormulaCondition, magFormula, "--", validationOptions, selectedAnswers[index]);

                       let isMagFormulaOneCorrect = VectorParserUtil.EvaluateVectorQueryOptions(selectedAnswers[index]?.mag,magFormulaCondition,magFormula,currentVectorVariable,validationOptions)

                       if(magAddFormulaFormulaOption){
                           let isMagFormulaTwoCorrect = VectorParserUtil.EvaluateVectorQueryOptions(selectedAnswers[index]?.mag,magFormulaConditionTwo,magFormulaTwo,currentVectorVariable,validationOptions)
                           if (magQueryOption == 0 ) {
                               //AND operator
                               isCorrectAnswerMag = isMagFormulaOneCorrect && isMagFormulaTwoCorrect;
                           } else if (magQueryOption == 1) {
                               //OR operator
                               isCorrectAnswerMag = isMagFormulaOneCorrect || isMagFormulaTwoCorrect;
                           }
                       } else {
                        isCorrectAnswerMag = isMagFormulaOneCorrect
                       }

                       //console.log("Vector answer Range----------_>isCorrectAnswerMag--->",isMagFormulaOneCorrect,isMagFormulaTwoCorrect,isCorrectAnswerMag)
   
                   }
   
                   if (vector_answer_formulas[index]?.evaluate_angle  === 0) {
                       const angFormulaCondition = vector_answer_formulas[index]?.angEvaluateOption;
                       const angFormula = vector_answer_formulas[index]?.angleFormula;
                       const angQueryOption = vector_answer_formulas[index]?.angQueryOption;
                       const angFormulaConditionTwo = vector_answer_formulas[index]?.angEvaluateOptionTwo;
                       const angFormulaTwo = vector_answer_formulas[index]?.angFormulaTwo;
                       const angAddFormulaFormulaOption = vector_answer_formulas[index]?.angAddFormulaSwitch;
   
                       let isAngFormulaOneCorrect = VectorParserUtil.EvaluateVectorQueryOptions(selectedAnswers[index]?.angle,angFormulaCondition,angFormula,currentVectorVariable,validationOptions)
                       
                       if(angAddFormulaFormulaOption){
                           let isAngFormulaTwoCorrect = VectorParserUtil.EvaluateVectorQueryOptions(selectedAnswers[index]?.angle,angFormulaConditionTwo,angFormulaTwo,currentVectorVariable,validationOptions)
                           if (angQueryOption == 0) {
                               //AND operator
                               isCorrectAnswerAng = isAngFormulaOneCorrect && isAngFormulaTwoCorrect;
                           } else if (angQueryOption == 1) {
                               //OR operator
                               isCorrectAnswerAng = isAngFormulaOneCorrect || isAngFormulaTwoCorrect;
                           }
                       } else {
                           isCorrectAnswerAng = isAngFormulaOneCorrect;
                       }
                       //console.log("Vector answer Range----------_>isAngFormulaOneCorrect--->",isAngFormulaOneCorrect,isAngFormulaOneCorrect,isAngFormulaOneCorrect)
   
                   }
   
                   if (vector_answer_formulas[index]?.evaluate_magnitue === 0 && vector_answer_formulas[index]?.evaluate_angle === 0) {
                       isCorrectAnswer = isCorrectAnswerMag && isCorrectAnswerAng
                   } else if (vector_answer_formulas[index]?.evaluate_magnitue === 0) {
                       isCorrectAnswer = isCorrectAnswerMag 
                   }else if (vector_answer_formulas[index]?.evaluate_angle === 0) {
                       isCorrectAnswer = isCorrectAnswerAng
                   }
   
                   console.log("Vector answer Range----------_>finalcorrectanswer",isCorrectAnswer,isCorrectAnswerMag,isCorrectAnswerAng)
               }
           }
            if(!isCorrectAnswer)
            {
                console.log("NotCorrectAnswer");
                return false;
            }
        }
        console.log("CorrectAnswer");
        return true;
    }

}